import { Portal } from './portal';

export class PortalSerializer {
  fromJson(json: any): Portal {
    const portal = new Portal();

    if (typeof json.data === 'undefined' || typeof json.success === 'undefined') {
      return this.toJson(json);
    } else {
      portal.success = json.success;
      portal.data = this.toJson(json.data);
      return portal;
    }

  }

  toJson(portal: Portal): any {
    if (typeof portal === 'object') {
      return {
        id: portal.id,
        main_setting_id: portal.main_setting_id,
        status: portal.status,
        name: portal.name,
        title: portal.title,
        days_before_evaluation: portal.days_before_evaluation,
        allow_registered_alt: portal.allow_registered_alt,
        allow_absent_alt: portal.allow_absent_alt,
        logo: portal.logo,
        institutional_color: portal.institutional_color,
        favicon: portal.favicon,
        background: portal.background,
        option_domain: portal.option_domain,
        system_domain: portal.system_domain,
        edited_by: portal.edited_by,
        tbc: portal.tbc,
        totvs_user: portal.totvs_user,
        totvs_pass: portal.totvs_pass,
        deleted_at: portal.deleted_at,
        created_at: portal.created_at,
        updated_at: portal.updated_at
      };
    } else {
      return portal;
    }
  }

}
